export const ActionDefaults = {
  create: {name: 'CREATE', title: '+Add', color: 'primary', icon: ''},
  edit: {name: 'EDIT', title: 'Edit', color: 'accent', icon: 'mdi-pencil'},
  assignDevice: {
    name: 'ASSIGN_DEVICE',
    title: 'Assign Device',
    color: 'accent',
    icon: 'mdi-hand-pointing-right',
  },
  changePriority: {
    name: 'Priority',
    title: 'Priority',
    color: 'accent',
    icon: 'mdi-content-duplicate',
  },
  setThreshold: {
    name: 'setThreshold',
    title: 'Threshold',
    color: 'accent',
    icon: 'mdi-car-speed-limiter',
  },
  delete: {
    name: 'DELETE',
    title: 'Delete',
    color: 'error',
    icon: 'mdi-delete',
    isConfirmationRequired: true,
  },
  complete: {
    name: 'COMPLETE',
    title: 'Complete',
    color: 'warning',
    icon: 'mdi-check',
    isConfirmationRequired: true,
  },
  cancelled: {
    name: 'CANCELLED',
    title: 'cancel',
    color: 'secondary',
    icon: 'mdi-cancel',
    isConfirmationRequired: true,
  },
  viewProfile: {name: 'VIEW', title: 'View', color: 'primary', icon: 'mdi-eye'},
  addAddons: {
    name: 'ADD_ADDONS',
    title: ' Add Addon',
    color: 'primary',
    icon: 'mdi-alarm-plus',
  },
  viewImage: {
    name: 'VIEW_IMAGE',
    title: 'Image',
    color: 'accent',
    icon: 'mdi-eye',
  },
  duplicate: {
    name: 'DUPLICATE',
    title: 'Duplicate',
    color: 'warning',
    icon: 'mdi-content-duplicate',
  },
  assignNurse: {
    name: 'ASSIGN_NURSE',
    title: 'Assign',
    color: 'secondary',
    icon: 'mdi-hand-pointing-right',
  },
  resendEmailToStaff: {
    name: 'RESEND_EMAIL_TO_STAFF',
    title: 'Resend Email',
    color: 'secondary',
    icon: 'mdi-email-outline',
  },
  resendEmailToDoctor: {
    name: 'RESEND_EMAIL_TO_DOCTOR',
    title: 'Resend Email',
    color: 'secondary',
    icon: 'mdi-email-outline',
  },
  block: {
    name: 'block',
    title: 'Block',
    color: 'secondary',
    icon: 'mdi-hand-pointing-right',
  },
  changeStatus: {
    name: 'CHANGE_STATUS',
    title: 'Change status',
    color: 'secondary',
    icon: 'mdi-pencil',
  },
  export: {
    name: 'EXPORT',
    title: 'Export',
    color: 'secondary',
    icon: 'mdi-export', // Correct MDI icon for export
  },
  //! Please CAPS WITH SNAKE CASE
  VIEW_DEVICE_INFO: {name: 'VIEW', title: 'View Device Info', color: 'primary', icon: 'mdi-eye'},

  ASSIGN_DEVICE_TO_PATIENT: {
    name: 'ASSIGN_DEVICE',
    title: 'Assign device',
    color: 'primary',
    icon: 'mdi-eye',
  },

  UNASSIGN_DEVICE_FROM_PATIENT: {
    name: 'UNASSIGN_DEVICE',
    title: 'Unassign device',
    color: 'warning',
    icon: 'mdi-link-off',
    isConfirmationRequired: true,
  },
  activate: {
    name: 'ACTIVATE',
    title: 'Activate',
    color: 'success',
    icon: 'mdi-check-circle',
  },
  deactivate: {
    name: 'DEACTIVATE',
    title: 'Deactivate',
    color: 'warning',
    icon: 'mdi-close-circle',
    isConfirmationRequired: true,
  },
  setTrialLimit: {
    name: 'SET_TRIAL',
    title: 'Set Trial Limit',
    color: 'accent',
    icon: 'mdi-speedometer'
  },
  cancelInvite: {
    name: 'CANCEL_INVITE',
    title: 'Cancel Invite',
    color: 'error',
    icon: 'mdi-cancel',
    isConfirmationRequired: true,
  },
  //! Please CAPS WITH SNAKE CASE
}
